import React from 'react';
import { Route, Switch } from "react-router-dom";
import InvestorRegistrationList from "./investor-registration-list/investor-registration-list";

const InvestorRegistrations = () => {
  return (
    <Switch>
      <Route exact path="/registrations">
        <InvestorRegistrationList />
      </Route>
    </Switch>
  )
}

export default InvestorRegistrations;
